import { render, staticRenderFns } from "./SubDesignationModal.vue?vue&type=template&id=b99a6016"
import script from "./SubDesignationModal.vue?vue&type=script&lang=js"
export * from "./SubDesignationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports